import { Box, darken, Typography, useTheme } from '@mui/material';
import { MdInfoOutline } from 'react-icons/md';
// import { useGetThirdPartyIntegrations } from 'apis/agency/thirdPartyIntegrations/hook';

export default function StripeBillingEnabledBanner() {
  const theme = useTheme();
  // const { data: integrations = [] } = useGetThirdPartyIntegrations();
  // const stripe = integrations.find((integration) => integration.provider === 'stripe');
  // const isStripeBillingEnabled = Boolean(stripe?.active && stripe?.enabled);

  // if (!isStripeBillingEnabled) return null;

  return (
    <Box
      mt={2}
      sx={{
        backgroundColor: theme.palette.primary.light,
        border: `1px solid ${darken(theme.palette.primary.light, 0.1)}`,
        borderRadius: 2,
        p: { xs: 1.5, sm: 2 },
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        width: '100%'
      }}
    >
      <Box
        component='span'
        sx={{
          width: { xs: 20, sm: 24 },
          height: { xs: 20, sm: 24 },
          mt: '2px',
          color: theme.palette.primary.main,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }}
      >
        <MdInfoOutline size={18} />
      </Box>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          fontWeight={500}
          color={theme.palette.primary.main}
          sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
        >
          Stripe Billing Enabled
        </Typography>
        <Typography color={theme.palette.primary.main} sx={{ fontSize: { xs: '12px', sm: '14px' }, mt: 0.5 }}>
          Stripe billing has been enabled through your third-party stripe configurations. All business payments and
          recurring charges will now be processed securely through the platform.
        </Typography>
      </Box>
    </Box>
  );
}
